<template>
  <b-modal title="Invite Agents" id="enterprise-invite" hide-footer>
    <p>Add all of the email addresses (comma separated) below that you would like to send an invitation to.</p>
    <textarea v-model="emails" placeholder="ex:johnsmith@agents.com,sallysmith@agents.com" style="width: 100%" rows="5"></textarea>

    <div class="mt-3">
      <b-button block variant="success" @click="sendInvites">Send Invitations</b-button>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  mixins: [errorsMixin],
  props: {
    userRoute: null
  },
  data() {
    return {
      emails: '',
    }
  },
  methods: {
    async sendInvites() {
      await axios.post(this.userRoute + "/invite", {
        emails: this.emails
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data.message,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.emails = '';
          this.$bvModal.hide('enterprise-invite');
        });
      })
      .catch(error => {
        this.error(error);
      });
    }
  }
}
</script>